import { ThemeModule } from '../../front/lib/ThemeModule';
import { makeFoldable } from '../../front/shared';
export class FaqEntry extends ThemeModule {
    init() {
        makeFoldable({
            container: this.getElementById('answer'),
            innerContainer: this.getElementById('answer-inner'),
            clickAreas: [this.getElementById('heading')],
            startsFolded: true,
        });
    }
}
